<template lang="en">
<div class="doctor-list">
    <Navigation></Navigation>


    <div id="results">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <h4  v-if="list && list.paginatorInfo">
                        <strong v-if="especiality.name">{{list.paginatorInfo.total}} resultados en {{title}} </strong> 
                        <span v-if="especiality.name && region.name">en {{region.name}}</span>
                    </h4>
                </div>
                <div class="col-md-6">
                    <SearchBar :especiality="especiality" :region="region"></SearchBar>
                </div>
            </div>
            <!-- /row -->
        </div>
        <!-- /container -->
    </div>
    <!-- /results -->


    <!-- <div class="filters_listing">
        <div class="container">
            <ul class="clearfix">
                <li>
                    <h6>Sub especialidades</h6>
                    <select name="orderby" class="selectbox">
						<option value="Closest">Todas</option>
						<option value="Best rated">Recomendados</option>
						<option value="Best rated">Grado</option>
						<option value="Best rated">Experiencia</option>
					</select>
                </li>
                <li>
					<h6>Layout</h6>
					<div class="layout_view">
						<a href="grid-list.html"><i class="icon-th"></i></a>
						<a href="#0" class="active"><i class="icon-th-list"></i></a>
						<a href="list-map.html"><i class="icon-map-1"></i></a>
					</div>
				</li>
                <li>
                    <h6>Ordenar por</h6>
                    <select name="orderby" class="selectbox">
						<option value="Closest">Disponibilidad</option>
						<option value="Best rated">Recomendados</option>
						<option value="Best rated">Grado</option>
						<option value="Best rated">Experiencia</option>
					</select>
                </li>
                <li>
                    <h6>Genero</h6>
                    <div class="switch-field">
                        <label for="all" :class="{'active':!filters.gender}" @click="filters.gender='';updateFilters()" >Todos</label>
                        <label for="male" :class="{'active':filters.gender=='male'}"  @click="filters.gender='male';updateFilters()" >Hombres</label>
                        <label for="female" :class="{'active':filters.gender=='female'}" @click="filters.gender='female';updateFilters()">Mujeres</label>
                    </div>
                </li>
            </ul>
        </div>
    </div> -->
    <!-- /filters -->

    <div class="container add_top_30 add_bottom_30">
        <div class="row">
			
            <div class="col col-lg-3">
                <div class="filters_listing">
                    <div class="">
                        <ul class="clearfix">
                            <li>
                                <h6>Sub especialidades</h6>
                                <select name="orderby" class="selectbox" @change="updateFilters($event)">
                                    <option value="all">Todas</option>
                                    <option value="Best rated">Recomendados</option>
                                    <option value="Best rated">Grado</option>
                                    <option value="Best rated">Experiencia</option>
                                </select>
                            </li>
                            <li>
                                <h6>Ordenar por</h6>
                                <select name="orderby" class="selectbox" v-model="filters.orderby" @change="updateFilters($event)">
                                    <option value="availability">Disponibilidad</option>
                                    <option value="featured">Recomendados</option>
                                </select>
                            </li>
                            <li>
                                <h6>Genero</h6>
                                <div class="switch-field">
                                    <label for="all" :class="{'active':!filters.gender}" @click="filters.gender='';updateFilters()" >Todos</label>
                                    <label for="male" :class="{'active':filters.gender=='male'}"  @click="filters.gender='male';updateFilters()" >Hombres</label>
                                    <label for="female" :class="{'active':filters.gender=='female'}" @click="filters.gender='female';updateFilters()">Mujeres</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-12 col-lg-9" v-if="loading">
                <Loader :show="loading" type="inline"></Loader>
            </div>

			<div class="col-md-12 col-lg-9" v-if="list && medicsList.length>0 && !loading">
                
                <div class="doctor-list-item" v-for="medic in medicsList" :key="medic.id">
                        
                    <figure>
                        <!-- <div class="donator-stamp" v-if="medic.isDonator"></div> -->
                        <div class="avatar" v-if="medic.picture" :style="'background-image:url('+API_URL+medic.picture.urlThumb+')'">
                        </div>
                        <div class="avatar" v-if="!medic.picture && medic.gender=='female'" :style="'background-image:url('+require('@/assets/img/no-avatar-image-female.jpg')+')'"></div>
                        <div class="avatar" v-if="!medic.picture && medic.gender=='male'" :style="'background-image:url('+require('@/assets/img/no-avatar-image-male.jpg')+')'"></div>
                    </figure>
                    
                    <router-link tag="div" :to="`/doctor/${medic.id}-${medic.slug}`" class="data">
                        <div class="especialities">
                            <small  v-for="medicEspeciality in medic.medicEspecialities" :key="medicEspeciality.id">
                                {{medicEspeciality.especiality.name}}
                            </small>
                        </div>

                        <h3 :class="{'has-donator-stamp':medic.isDonator}">
                            {{medic.fullname}}

                            <div class="donator-stamp" v-if="medic.isDonator"></div>
                        </h3>
                        <p v-if="medic.medicBusinessAddresses[0]">
                            {{medic.medicBusinessAddresses[0].locality.name}} | <span class="text-black-50">{{medic.medicBusinessAddresses[0].locality.region.name}}</span>
                        </p>
						<!-- <star-rating :star-size="14" :read-only="true" :show-rating="false" :rating="medic.rate"  inactive-color="#ddd" :inline="true"></star-rating> -->
                        <hr>
                        <!-- <div class="btn btn-sm btn-warning mb-2" v-if="!medic.nextAvailability && !medic.nextVideoAvailability">Agenda completa</div> -->
                        <div class="btn btn-sm btn-light mb-2" v-if="medic.nextAvailability && medic.nextVideoAvailability">Ver mas disponibilidad</div>

                    </router-link>
                    

                    <div class="book-info" v-if="medic.nextVideoAvailability && !medic.requestVideoHours">
                        <div class="next-availability">
                            <h3>
                                <small>PROXIMA HORA DISPONIBLE</small>
                                {{medic.nextVideoAvailability.datetime | moment("DD MMM") }} {{medic.nextVideoAvailability.datetime | moment("HH:mm") }}
                                <br>
                                <span class="price">$ {{medic.nextVideoAvailability.price}}</span>
                            </h3>
                        </div>
                        <router-link tag="a" class=" btn book book-video mb-2" :to="`/doctor/${medic.id}-${medic.slug}?especiality=${especiality.slug}&datetime=${medic.nextVideoAvailability.datetime}&channel=video`">
                            <i class="icon-videocam"></i> Reservar
                        </router-link>
                    </div>

                    <div class="book-info" v-if="medic.requestVideoHours">
                        <div class="next-availability" >
                            <h3 v-if="medic.priceVideo">
                                <small>PRECIO POR CONSULTA</small>
                                <span class="price">$ {{medic.priceVideo}}</span>
                            </h3>
                        </div>
                        <router-link tag="a" class="btn book book-hours video mb-2" :to="`/doctor/${medic.id}-${medic.slug}?especiality=${especiality.slug}&requestHours=video`">
                            <i class="icon-videocam"></i> Solicitar horas
                        </router-link>
                    </div>
                    <!-- <div class="book-info" v-if="medic.hasChannelVideo && medic.nextVideoAvailability && (filters.channel == 'video' || !filters.channel) ">
                        <div class="next-availability">
                            <h3>
                                <small>PROXIMA HORA DISPONIBLE</small>
                                {{medic.nextVideoAvailability.datetime | moment("DD MMM") }} {{medic.nextVideoAvailability.datetime | moment("HH:mm") }}
                                <br>
                                <span class="price">$ {{medic.medicEspecialities | getEspecialityPrice(especiality, 'video') }}</span>
                            </h3>
                        </div>
                        <router-link tag="a" class=" btn book book-video" :to="`/doctor/${medic.id}-${medic.slug}?especiality=${especiality.slug}&datetime=${medic.nextVideoAvailability.datetime}&channel=video`">
                            <i class="icon-videocam"></i> Reservar
                        </router-link>
                    </div> -->

                    <div class="book-info" v-if="medic.nextAvailability && !medic.requestHours">
                        <div class="next-availability" >
                            <h3>
                                <small>PROXIMA HORA DISPONIBLE</small>
                                {{medic.nextAvailability.datetime | moment("DD MMM") }} {{medic.nextAvailability.datetime | moment("HH:mm") }}
                                <br>
                                <span class="price">$ {{medic.nextAvailability.price}}</span>
                            </h3>
                        </div>
                        <router-link tag="a" class=" btn book mb-2" :to="`/doctor/${medic.id}-${medic.slug}?especiality=${especiality.slug}&datetime=${medic.nextAvailability.datetime}&channel=presential`">
                            <i class="icon_house"></i> Reservar
                        </router-link>
                    </div>

                    <div class="book-info" v-if="medic.requestHours">
                        <div class="next-availability" >
                            <h3 v-if="medic.price">
                                <small>PRECIO POR CONSULTA</small>
                                <span class="price">$ {{medic.price}}</span>
                            </h3>
                        </div>
                        <router-link tag="a" class="btn book book-hours mb-2" :to="`/doctor/${medic.id}-${medic.slug}?especiality=${especiality.slug}&requestHours=presential`">
                            <i class="icon_house"></i> Solicitar horas
                        </router-link>
                    </div>
                </div>
                
                <nav aria-label="" class="add_top_20">
                    <b-pagination
                        v-model="pagination.page"
                        :total-rows="list.paginatorInfo.total"
                        :per-page="pagination.length"
                        first-text="Primera"
                        prev-text="Anterior"
                        next-text="Siguiente"
                        last-text="Última"
                        align="right"
                        @input="pageChange"
                    ></b-pagination>
                </nav>
            </div>

            <div class="col-md-12 col-lg-9" v-if="list.data.length==0 && !loading">
                <div class="alert alert-warning" >
                    <h4>Upss! <small>Lamentablemente, todas las consultas están reservadas.</small></h4>
                    Completa el siguiente formulario para notificarnos e intentaremos conseguirte la consulta que estás buscando.<br>
                    <!-- <a :href="`mailTo:hello@doctorconsultas.com?Subject=No Disponibilidad&Body=No he encontrado médicos diponibles para: ${title}`" class="pull-right m-3 btn btn-warning btn-sm">
                        Contactanos
                    </a> -->

                    <ContactForm 
                        class="mt-4" 
                        subject="Busqueda vacia">
                    </ContactForm>

                </div>
            </div>


        </div>
        
    </div>

    <Footer></Footer>

</div>
</template>

<script>
import gql from 'graphql-tag'
import Navigation from '@/components/Navigation'
import Footer from '@/components/Footer'
import Loader from '@/components/Loader'
import SearchBar from '@/components/SearchBar'
import ListSchedule from '@/components/ListSchedule'
import ContactForm from '@/components/ContactForm'

export default {
	name: 'DoctorList',
	metaInfo() {
		return {
			title: this.title,
		}
	},
	components: {
		Navigation,
		Footer,
		SearchBar,
		ListSchedule,
		Loader,
		ContactForm,
	},
	computed: {
		medicsList: function() {
			return this.list.data.map((medic) => {
				// console.log(medic)
				// console.log(this.especiality)
				// console.log(this.filters)
				if (medic.nextVideoAvailability) {
					medic.nextVideoAvailability.price = this.getCheapestPrice(medic, 'video')
				}
				if (medic.nextAvailability) {
					medic.nextAvailability.price = this.getCheapestPrice(medic, 'presential')
				}
				// si tengo especialidad, tengo que mostrar las diponibilidades de esa misma especialidad
				if (this.especiality) {
					medic.medicEspecialities.forEach((medicEspeciality) => {
						if (medicEspeciality.especiality.id == this.especiality.id) {
							if (this.filters.channel == 'video') {
								medic.nextVideoAvailability = medicEspeciality.nextVideoAvailability
								if (medic.nextVideoAvailability) {
									medic.nextVideoAvailability.price = medicEspeciality.price_video
								}
								medic.nextAvailability = null
							} else if (this.filters.channel == 'presential') {
								medic.nextVideoAvailability = null
								medic.nextAvailability = medicEspeciality.nextAvailability
								if (medic.nextAvailability) {
									medic.nextAvailability.price = medicEspeciality.price
								}
							} else {
								medic.nextVideoAvailability = medicEspeciality.nextVideoAvailability
								if (medic.nextVideoAvailability) {
									medic.nextVideoAvailability.price = medicEspeciality.price_video
								}
								medic.nextAvailability = medicEspeciality.nextAvailability
								if (medic.nextAvailability) {
									medic.nextAvailability.price = medicEspeciality.price
								}
							}
						}
					})
				}

				// veo si tnego que mostrar el requestHours
				if (!medic.nextAvailability && (this.filters.channel == 'presential' || !this.filters.channel)) {
					medic.requestHours = true
				}
				if (!medic.nextVideoAvailability && (this.filters.channel == 'video' || !this.filters.channel)) {
					medic.requestVideoHours = true
				}

				if (!medic.status || medic.status == '0') {
					medic.requestHours = true
					medic.requestVideoHours = true
				}

				medic.price = this.getEspecialityPrice(medic, 'presential')
				medic.priceVideo = this.getEspecialityPrice(medic, 'video')

				// if(medic.hasChannelVideo && medic.nextVideoAvailability && ( this.filters.channel == 'video' || !this.filters.channel)){
				//     medic.nextVideoAvailability = medic.nextVideoAvailability
				// }

				return medic
			})
		},
	},
	data() {
		return {
			list: {
				data: [],
			},
			title: 'Buscar doctor',
			region: {
				slug: this.$route.params.region,
				name: '',
			},
			especiality: {
				id: null,
				slug: this.$route.params.especiality,
				name: '',
			},
			filters: {
				orderby: 'availability',
				// channel: this.$route.query.channel
			},
			toggleFilters: false,
			pagination: {
				page: 1,
				length: 12,
			},
			loading: true,
			API_URL: process.env.VUE_APP_API_URL,
		}
	},
	watch: {
		'pagination.page': function(newVal, oldVal) {
			if (newVal != oldVal) window.scrollTo(0, 0)
		},
	},
	async beforeMount() {
		await this.preloadUrlData()
		await this.loadFilters()
	},
	filters: {},
	methods: {
		getCheapestPrice(medic, channel) {
			let cheapestPrice = 0
			if (medic.medicEspecialities.length > 0) {
				medic.medicEspecialities.forEach((medicEspeciality) => {
					let price = 0
					if (channel == 'video') {
						price = medicEspeciality.price_video
					} else {
						price = medicEspeciality.price
					}

					if (cheapestPrice == 0 || (cheapestPrice > price && price > 0)) {
						cheapestPrice = price
					}
				})
			}
			// if( price == 0 ){
			//     cheapestPrice = cheapestPrice;
			// }
			return cheapestPrice
		},
		getEspecialityPrice(medic, channel) {
			let price = 0
			if (medic.medicEspecialities.length > 0) {
				medic.medicEspecialities.forEach((medicEspeciality) => {
					if (medicEspeciality.especiality.id == this.especiality.id) {
						if (channel == 'video') {
							price = medicEspeciality.price_video
						} else {
							price = medicEspeciality.price
						}
					}
				})
			}
			return price
		},
		loadFilters() {
			this.filters = {} //reseteo filtros

			if (this.$route.query.gender == 'male' || this.$route.query.gender == 'female') {
				this.filters.gender = this.$route.query.gender
			}
			if (this.$route.query.orderby) {
				this.filters.orderby = this.$route.query.orderby
			}
			if (this.$route.query.page > 0) {
				this.pagination.page = parseInt(this.$route.query.page)
			}

			if (this.$route.query.channel) {
				this.filters.channel = this.$route.query.channel
			}
			if (!this.$route.params.especiality && !this.$route.params.region) {
				//si no tengo ni especialidad ni region determinada, tengo que cargar los featured por defecto.
				this.filters.orderby = 'featured'
			}
			this.search()
		},
		updateFilters() {
			this.pagination.page = 1
			if (this.filters.gender != 'male' && this.filters.gender != 'female') {
				delete this.filters.gender
			}
			if (this.filters.orderby == '') {
				delete this.filters.orderby
			}
			if (this.filters.type <= 0) {
				delete this.filters.type
			}
			if (!this.filters.channel) {
				delete this.filters.channel
			}
			this.$router.push({ query: this.filters })
		},
		pageChange() {
			this.$router.push({ query: { page: this.pagination.page } })
			// console.log('pageChange', this.pagination.page)
			// this.pagination.page = page+1;
		},
		preloadUrlData() {
			if (this.$route.params.especiality || this.$route.params.region) {
				this.title = ''
			}

			if (this.$route.params.especiality) {
				this.$apollo
					.query({
						query: gql`
							query get($especialitySlug: String!) {
								especiality(slug: $especialitySlug) {
									id
									name
									slug
								}
							}
						`,
						variables: {
							especialitySlug: this.$route.params.especiality,
						},
					})
					.then((data) => {
						this.especiality = data.data.especiality
						this.title = this.title.concat(' ', this.especiality.name)
					})
					.catch((error) => {
						console.log(error)
					})
			}
			if (this.$route.params.region) {
				this.$apollo
					.query({
						query: gql`
							query get($regionSlug: String!) {
								region(slug: $regionSlug) {
									id
									name
									slug
								}
							}
						`,
						variables: {
							regionSlug: this.$route.params.region,
						},
					})
					.then((data) => {
						this.region = data.data.region
						this.title = this.title.concat(' en ', this.region.name)
					})
					.catch((error) => {
						console.log(error)
					})
			}
		},
		search() {
			this.$apollo
				.query({
					query: gql`
						query getMedics(
							$count: Int!
							$page: Int
							$search: String
							$gender: String
							$especiality: String
							$region: String
							$channel: String
						) {
							medics(
								count: $count
								page: $page
								search: $search
								gender: $gender
								especiality: $especiality
								region: $region
								channel: $channel
							) {
								paginatorInfo {
									count
									currentPage
									total
								}
								data {
									id
									fullname
									prefix
									slug
									gender
									cjp
									picture {
										urlThumb
									}
									medicBusinessAddresses {
										id
										locality {
											name
											region {
												name
											}
										}
									}
									rate
									hasChannelPresential
									nextAvailability {
										datetime
									}
									hasChannelVideo
									nextVideoAvailability {
										datetime
									}
									medicEspecialities {
										especiality {
											id
											name
										}
										price
										price_video
										channel_video
										channel_presential
										nextAvailability {
											datetime
										}
										nextVideoAvailability {
											datetime
										}
									}
									isDonator
									status
								}
							}
						}
					`,
					variables: {
						page: this.pagination.page,
						count: this.pagination.length,
						orderby: this.filters.orderby,
						gender: this.filters.gender,
						especiality: this.especiality.slug,
						region: this.region.slug,
						channel: this.filters.channel,
					},
				})
				.then((data) => {
					this.list = data.data.medics
					this.loading = false
					this.checkIfMedicsHasHours()
				})
				.catch((error) => {
					this.loading = false
					console.log(error)
				})
		},

		checkIfMedicsHasHours() {
			var hasHours = false

			if (this.list.data.length > 0) {
				// si la lista no esta vacia, busco si hay algun medico que no tenga horas.
				this.list.data.forEach((medic) => {
					if (medic.nextAvailability) {
						hasHours = true
					}
					if (medic.nextVideoAvailability) {
						hasHours = true
					}
				})
			}
			if (!hasHours) {
				this.saveFailedSearch(this.especiality.id, '')
			}
		},

		saveFailedSearch(especiality_id, keywords) {
			console.log('saveFailedSearch', especiality_id, keywords)
			var dataInput = {
				especiality_id: especiality_id,
				keywords: keywords,
			}
			this.$apollo.mutate({
				mutation: gql`
					mutation($data: FailedSearchInput!) {
						createFailedSearch(data: $data) {
							id
						}
					}
				`,
				variables: {
					data: dataInput,
				},
			})
		},
	},
}
</script>

<style scoped>
/*-------- 2.2 Listing --------*/
#results {
	padding: 10px 0;
	color: #000;
	background: #e8ecef;
}

@media (max-width: 767px) {
	#results {
		/* For less than 767px */
		padding: 10px 0;
	}
}

#results.is_stuck {
	z-index: 99;
}

#results h4 {
	color: #666;
	margin: 15px 0 0 8px;
	font-size: 1rem;
}

@media (max-width: 767px) {
	#results h4 {
		/* For less than 767px */
		display: none;
	}
}

.box_list {
	background-color: #fff;
	display: block;
	position: relative;
	margin-bottom: 30px;
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	-ms-border-radius: 5px;
	border-radius: 5px;
	-webkit-box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
	-moz-box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
	box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
}

@media (max-width: 991px) {
	.box_list {
		/* For less than 991px */
		min-height: inherit;
	}
}

.box_list figure {
	margin-bottom: 0;
	overflow: hidden;
	position: relative;
	-webkit-border-radius: 5px 5px 0 0;
	-moz-border-radius: 5px 5px 0 0;
	-ms-border-radius: 5px 5px 0 0;
	border-radius: 5px 5px 0 0;
	-webkit-backface-visibility: hidden;
	-moz-backface-visibility: hidden;
	-ms-backface-visibility: hidden;
	-o-backface-visibility: hidden;
	backface-visibility: hidden;
	height: 260px;
}

@media (max-width: 767px) {
	.box_list figure {
		/* For less than 767px */
		height: 280px;
	}
}

.box_list figure .preview {
	position: absolute;
	top: 50%;
	left: 0;
	margin-top: -12px;
	-webkit-transform: translateY(10px);
	-moz-transform: translateY(10px);
	-ms-transform: translateY(10px);
	-o-transform: translateY(10px);
	transform: translateY(10px);
	text-align: center;
	opacity: 0;
	visibility: hidden;
	width: 100%;
	-webkit-transition: all 0.6s;
	transition: all 0.6s;
	z-index: 2;
}

.box_list figure .preview span {
	background-color: #fcfcfc;
	background-color: rgba(255, 255, 255, 0.8);
	-webkit-border-radius: 20px;
	-moz-border-radius: 20px;
	-ms-border-radius: 20px;
	border-radius: 20px;
	display: inline-block;
	color: #222;
	font-size: 0.75rem;
	padding: 5px 15px;
}

.box_list figure:hover .preview {
	opacity: 1;
	visibility: visible;
	-webkit-transform: translateY(0);
	-moz-transform: translateY(0);
	-ms-transform: translateY(0);
	-o-transform: translateY(0);
	transform: translateY(0);
}

.box_list figure a img {
	-webkit-transform: scale(1);
	-moz-transform: scale(1);
	-ms-transform: scale(1);
	-o-transform: scale(1);
	transform: scale(1);
	-moz-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out;
}

.box_list figure a:hover img {
	-webkit-transform: scale(1.1);
	-moz-transform: scale(1.1);
	-ms-transform: scale(1.1);
	-o-transform: scale(1.1);
	transform: scale(1.1);
}

.box_list .wrapper {
	padding: 25px;
}

.box_list .wrapper h3 {
	font-size: 1.25rem;
	margin-top: 0;
}

@media (max-width: 767px) {
	.box_list .wrapper p {
		/* For less than 767px */
		font-size: 13px;
		font-size: 0.8125rem;
	}
}

.box_list small {
	text-transform: uppercase;
	color: #999;
	font-weight: 600;
}

.box_list ul {
	width: 100%;
	padding: 20px 15px;
	border-top: 1px solid #ededed;
}

@media (max-width: 991px) {
	.box_list ul {
		/* For less than 991px */
		position: static;
	}
}

.box_list ul li {
	display: inline-block;
	color: #999;
	font-weight: 500;
}

.box_list ul li i {
	margin-right: 5px;
	font-weight: 500;
}

@media (max-width: 767px) {
	.box_list ul li:first-child {
		/* For less than 767px */
		display: none;
	}
}

.box_list ul li:nth-child(2) {
	display: none;
}

@media (max-width: 767px) {
	.box_list ul li:nth-child(2) {
		/* For less than 767px */
		display: inline-block;
	}
}

.btn.book {
	font-weight: 500;
	border: 2px solid #7ad6cb;
	color: #7ad6cb;
	cursor: pointer;
	padding: 4px 16px;
	font-size: 0.9rem;
	margin-right: 0;
	-moz-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out;
	-webkit-border-radius: 30px;
	-moz-border-radius: 30px;
	-ms-border-radius: 30px;
	border-radius: 30px;
	display: table;
}

.btn.book:hover {
	background-color: #7ad6cb;
	color: white !important;
}

.btn.book-video {
	border: 2px solid #548cb3;
	color: #548cb3;
}
.btn.book-video:hover {
	background-color: #548cb3;
	color: white !important;
}

.btn.book.book-hours {
	padding: 4px 6px;
	border: 2px solid #f19600;
	color: #f19600;
}

.btn.book.book-hours:hover {
	background-color: #f19600;
	color: white !important;
}

.btn-secondary {
}

.box_list ul li:last-child {
	margin-right: 0;
	float: right;
}

.box_list ul li:last-child a {
	background: #fff;
	border: 2px solid #e74e84;
	color: #e74e84;
	padding: 5px 20px;
	font-weight: 500;
	line-height: 1;
	-moz-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out;
	-webkit-border-radius: 30px;
	-moz-border-radius: 30px;
	-ms-border-radius: 30px;
	border-radius: 30px;
}

.box_list ul li:last-child a:hover {
	background: #e74e84;
	color: #fff;
}

.box_list.home ul li:first-child,
.box_list.home ul li:nth-child(2),
.box_list.home ul li:last-child {
	display: inline-block;
}

a.wish_bt {
	position: absolute;
	right: 15px;
	top: 15px;
	z-index: 2;
	background-color: black;
	background-color: rgba(0, 0, 0, 0.6);
	padding: 9px 10px;
	display: inline-block;
	color: #fff;
	line-height: 1;
	-webkit-border-radius: 3px;
	-moz-border-radius: 3px;
	-ms-border-radius: 3px;
	border-radius: 3px;
	-moz-transition: all 0.5s ease;
	-o-transition: all 0.5s ease;
	-webkit-transition: all 0.5s ease;
	-ms-transition: all 0.5s ease;
	transition: all 0.5s ease;
}

a.wish_bt:after {
	font-family: 'ElegantIcons';
	content: '\e030';
}

a.wish_bt:hover:after {
	content: '\e089';
	color: #e74e84;
}

.doctor-list-item {
	display: flex;
	margin-bottom: 12px;

	background-color: #fff;
	padding: 12px 4px 4px 7px;
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	-ms-border-radius: 5px;
	border-radius: 5px;
	position: relative;
	-webkit-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
	-moz-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
	box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
}
.doctor-list-item figure {
	width: 80px;
	height: 80px;
	margin: 8px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	-ms-border-radius: 50%;
	border-radius: 50%;
	position: relative;
}
.doctor-list-item figure .avatar {
	border-radius: 50%;
}
.doctor-list-item figure img {
	width: auto;
	height: 80px;
}

.donator-stamp {
	position: absolute;
	/* bottom: -12px; */
	background-color: #fff;
	border-radius: 50%;
	right: 0px;
	top: -3px;
	width: 38px;
	height: 38px;
}

@media (max-width: 767px) {
	.strip_list figure {
		width: 60px;
		height: 60px;
	}
}

.doctor-list-item .data {
	flex-grow: 1;
}

.doctor-list-item .data:hover {
	cursor: pointer;
}

.doctor-list-item .data p {
	margin: 0px;
}

.doctor-list-item .data h3 {
	margin: 0px;
	font-size: 22px;
	font-size: 1.375rem;
	margin: 0px;
	display: inline-block;
	position: relative;
}
.doctor-list-item .data h3.has-donator-stamp {
	padding-right: 44px;
}
.doctor-list-item .data:hover h3 {
	color: #12bcec;
}

.doctor-list-item .data .especialities {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	position: relative;
}
.doctor-list-item .data .especialities:after {
	content: '';
	width: 50px;
	height: 20px;
	position: absolute;
	right: 0px;
	background: rgba(255, 255, 255, 0);
	background: -moz-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 59%, rgba(255, 255, 255, 1) 100%);
	background: -webkit-gradient(
		left top,
		right top,
		color-stop(0%, rgba(255, 255, 255, 0)),
		color-stop(59%, rgba(255, 255, 255, 1)),
		color-stop(100%, rgba(255, 255, 255, 1))
	);
	background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 59%, rgba(255, 255, 255, 1) 100%);
	background: -o-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 59%, rgba(255, 255, 255, 1) 100%);
	background: -ms-linear-gradient(left, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 59%, rgba(255, 255, 255, 1) 100%);
	background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 59%, rgba(255, 255, 255, 1) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ffffff', GradientType=1 );
}

.doctor-list-item .data hr {
	margin: 4px 0px;
}

.doctor-list-item .data .btn-secondary {
}

.book-info {
	width: 148px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-end;
}
.next-availability {
}

.next-availability h3 {
	text-align: center;
	font-size: 16px;
	line-height: 22px;
}
.next-availability h3 small {
	font-size: 9px;
	display: block;
	width: 100%;
}
.next-availability h3 span {
	font-size: 14px;
	display: block;
}
.next-availability h3 span.price {
	font-size: 14px;
	display: block;
}

.doctor-list-item .especialities small {
	display: inline;
}
.doctor-list-item .especialities small:not(:last-child):after {
	content: '|';
}

.doctor-list-item .doctor-item-schedule {
	background-color: #fff;
	border-radius: 0px 5px 5px 0px;
	padding: 8px;
	flex-grow: 0;
}

@media (max-width: 490px) {
	.doctor-list-item {
		display: block;
	}
}

@media (max-width: 767px) {
	.doctor-list-item .data {
		display: block;
		text-align: center;
	}
	.doctor-list-item .book-info {
		display: block;
		text-align: center;
		margin: auto;
	}

	.doctor-list-item figure {
		display: none;
	}
}

@media (max-width: 992px) {
	.doctor-list-item .strip_list {
		border-radius: 5px 5px 0px 0px;
	}

	.doctor-list-item .doctor-item-schedule {
		border-radius: 0px 0px 5px 5px;
	}
}

.strip_list a.wish_bt {
	background-color: black;
	background-color: rgba(0, 0, 0, 0.05);
	-webkit-border-radius: 3px;
	-moz-border-radius: 3px;
	-ms-border-radius: 3px;
	border-radius: 3px;
	color: #555;
}

.strip_list a.wish_bt:hover:after {
	color: #e74e84;
}

@media (max-width: 767px) {
	.strip_list {
		/* For less than 767px */
		padding: 20px 15px 15px 90px;
	}
}

@media (max-width: 767px) {
	.strip_list p {
		/* For less than 767px */
		font-size: 13px;
		font-size: 0.8125rem;
	}
}

.strip_list small {
	color: #999;
	display: block;
	font-weight: 600;
	text-transform: uppercase;
}

.strip_list ul {
	border-top: 1px solid #ededed;
	margin: 15px -15px -15px -115px;
	padding: 20px 15px;
}

@media (max-width: 767px) {
	.strip_list ul {
		/* For less than 767px */
		margin: 15px -15px -15px -90px;
	}
}

.strip_list ul li {
	display: inline-block;
	margin-right: 5px;
	font-weight: 500;
}

.strip_list ul li a {
	color: #999;
	cursor: pointer;
}

.strip_list ul li a:hover {
	color: #e74e84;
}

.strip_list ul li:first-child:after {
	content: '|';
	font-weight: 400;
	margin-left: 8px;
	color: #ccc;
}

@media (max-width: 991px) {
	.strip_list ul li:first-child {
		/* For less than 991px */
		display: none;
	}
}

.rating i {
	color: #ddd;
	font-size: 13px;
	font-size: 0.8125rem;
}

.rating i.voted {
	color: #ffc107;
}

.rating small {
	margin-bottom: 0;
	display: inline-block;
	font-size: 12px;
	font-size: 0.75rem;
}

.rating small a {
	color: #999;
	text-decoration: underline;
}

.filters_listing {
	border: none;
	padding: 0px 0;
	margin-bottom: 8px;
}

.filters_listing.map_listing {
	border-bottom: none;
}

.filters_listing ul {
	margin: 0;
}

.filters_listing ul li {
	margin: 8px 0px;
	width: 100%;
	float: none;
}

.filters_listing ul li h6 {
	font-size: 12px;
	font-size: 0.75rem;
	color: #999;
	margin-bottom: 3px;
}

.filters_listing ul li .selectbox {
	width: 100%;
}
.filters_listing .switch-field label {
	width: 100%;
	border-radius: 3px;
	margin: 0px;
}

.filters_listing ul li:nth-child(3) {
	float: right;
}

@media (max-width: 991px) {
	.filters_listing {
		border-bottom: 1px solid #e1e8ed;
	}
	.filters_listing ul li {
		margin-right: 10px;
		width: auto;
	}

	.filters_listing ul li:first-child {
		float: left;
	}

	.filters_listing ul li:nth-child(2) {
		float: right;
		margin-right: 0;
	}
	.filters_listing .switch-field label {
		width: auto;
	}
}

@media (max-width: 767px) {
	.filters_listing ul li:nth-child(2) {
		/* For less than 767px */
		float: left;
	}

	.filters_listing ul li:nth-child(3) {
		float: left;
		clear: both;
	}
	.filters_listing ul li h6 {
		display: none;
	}
}
</style>
